Vue.component('ack-contact-us', {
	delimiters: ['${', '}$'],
	template: '#ack-contact-us',
	props: ['contactUsPageDataUrl'],
	data() {
		return {
			pageId: 'contact-us',
			currentPageInfo: {},
			pagesInfo: {},
			isMobile: false,
			homePage: 'contact_us',
			currentPage: '',
			parentLinks: [],
		};
	},
	created() {
		this.getPageData();
	},
	methods: {
		checkDevice() {
			this.isMobile = window.innerWidth <= 768;
		},
		getPageData() {
			fetch(this.contactUsPageDataUrl)
				.then((res) => res.json())
				.then((data) => {
					data = window.ackNormalizeShopifyFileUrls
						? window.ackNormalizeShopifyFileUrls(data)
						: data;
					this.pagesInfo = data;
					this.currentPageInfo = data[this.homePage];
					this.currentPage = this.homePage;
				})
				.catch((err) => console.error(err));
		},
		isRedirectToExternal(link) {
			return link.startsWith('https://');
		},
		onLinkClick(redirectLink, event) {
			if (this.isRedirectToExternal(redirectLink)) return;
			event.preventDefault();

			this.parentLinks.push(this.turnPageNameToPageInfoKey(this.currentPageInfo.page_name));
			this.changePage(redirectLink);
		},
		changePage(newPage) {
			if (newPage === this.homePage) {
				this.parentLinks = [];
			}
			this.currentPage = newPage;
			this.currentPageInfo = this.pagesInfo[this.currentPage];
		},
		onBreadCrumbsLinkClick(redirectLink, linkIndex, event) {
			event.preventDefault();
			this.parentLinks.splice(linkIndex);
			this.changePage(redirectLink);
		},
		navigateBack() {
			const redirectPage = this.parentLinks.pop();
			this.changePage(redirectPage);
		},
		turnPageNameToPageInfoKey(value) {
			return value.toLocaleLowerCase().split(' ').join('_');
		},
		showPageName(parentLink) {
			return parentLink === this.homePage ? 'Home Page' : this.pagesInfo[parentLink].page_name;
		},
	},
	mounted() {
		this.checkDevice();
		window.addEventListener('resize', this.checkDevice);
	},
	computed: {
		isMobileHomepage() {
			return this.currentPage === this.homePage && this.isMobile;
		},
	},
	destroyed() {
		window.removeEventListener('resize', this.checkDevice);
	},
});
